import { classInstance } from '@/shared/helpers/helpers';

export class AccountOrder {
	private element: HTMLElement;
	private activeClass: string = 'account-order--active';
	private headerSelector: string = '.account-order__header';

	constructor(element) {
		if (!element) return;
		this.element = element;
		this.init();
	}

	private handleClick = ({ target }): void => {
		if (target.closest(this.headerSelector)) this.element.classList.toggle(this.activeClass);
	};

	public init = (): void => {
		classInstance.set(this.element, { accountOrder: this });
		this.element.addEventListener('click', this.handleClick);
	};

	public destroy = (): void => {
		classInstance.del(this.element, 'accountOrder');
		this.element.removeEventListener('click', this.handleClick);
	};
}
